module.exports = __webpack_public_path__ + "static/img/join.4d59511.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGya/join.png
// module id = 1141
// module chunks = 18